<div class="col-12"
    [ngClass]="item?.alignment" 
    [style.padding-top.px]="item?.padding"
    [style.padding-bottom.px]="item?.padding" 
    *ngIf="item?.type == 'LINK'" 
>
    <ng-container *ngIf="!item?.content?.link?.includes('http')">
        <a routerLink="{{ item?.content?.link }}">
            <button type="button" class="btn btn-lg font-size-16 text-primary font-weight-bold">
                <i class="fas fa-arrow-left text-primary"></i> {{ item?.content?.text }}
            </button>
        </a>
    </ng-container>

    <ng-container *ngIf="item?.content?.link?.includes('http')">
        <a href="{{ item?.content?.link }}" target="_blank">
            <button type="button" class="btn btn-lg font-size-16 text-primary font-weight-bold">
                <i class="fas fa-arrow-left text-primary"></i> {{ item?.content?.text }}
            </button>
        </a>
    </ng-container>
</div>